import { useState, useEffect } from "react";
import { BookOpen } from "lucide-react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function VerseOfTheDay() {
  const [verse, setVerse] = useState({
    texto: "Todo lo puedo en Cristo que me fortalece.",
    cita: "Filipenses 4:13"
  });

  useEffect(() => {
    const fetchVerse = async () => {
      try {
        const res = await axios.get(`${API}/landing/verse-of-the-day`);
        if (res.data && res.data.texto) {
          setVerse(res.data);
        }
      } catch (e) {
        console.error("Error fetching verse:", e);
      }
    };
    fetchVerse();
  }, []);

  return (
    <section
      data-testid="verse-of-the-day"
      className="animate-stagger-2 px-5 py-6"
    >
      <div className="relative overflow-hidden rounded-2xl bg-white border border-gray-200 p-6 shadow-sm">
        {/* Subtle decorative accents */}
        <div className="absolute top-0 right-0 w-32 h-32 bg-[#00CCFF]/5 rounded-full blur-3xl" />
        <div className="absolute bottom-0 left-0 w-24 h-24 bg-[#056A84]/5 rounded-full blur-2xl" />

        {/* Quote mark */}
        <div className="absolute top-3 left-4 text-[#056A84]/10 text-6xl font-serif leading-none select-none">
          &ldquo;
        </div>

        <div className="relative z-10">
          <div className="flex items-center gap-2 mb-4">
            <BookOpen className="w-4 h-4 text-[#056A84]" strokeWidth={2} />
            <span className="text-[10px] font-heading uppercase tracking-[0.25em] text-[#056A84] font-semibold">
              Versículo del Día
            </span>
          </div>

          <blockquote className="font-accent text-lg md:text-xl text-[#111827] italic leading-relaxed mb-4 pl-1">
            {verse.texto}
          </blockquote>

          <div className="flex items-center gap-3">
            <div className="h-px flex-1 bg-gradient-to-r from-[#056A84]/20 to-transparent" />
            <cite
              data-testid="verse-citation"
              className="text-xs text-[#056A84] not-italic font-heading font-semibold tracking-wider whitespace-nowrap"
            >
              {verse.cita}
            </cite>
          </div>
        </div>
      </div>
    </section>
  );
}
